import {
  Box,
  Button,
  TextField,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { generateAndExecuteMutation } from "../../../../data/Axios/DynamicService";
import Header from "../../../../components/Header";
import { AccountsandFinanceurl } from "../../../../config";

const base_url = AccountsandFinanceurl.uri;

const DepreciationMethodsForm = (props) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const initialValues = {
    methodName: props.data?.methodName || "",
    description: props.data?.description || "",
  };

  const validationSchema = yup.object().shape({
    methodName: yup.string().required("Method name is required"),
    description: yup.string().required("Description is required"),
  });

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userIdFromSession = parseInt(decodedToken.Id);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { methodName, description } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            methodName,
            description,
            updatedBy: userIdFromSession,
            isActive: true,
          }
        : {
            methodName,
            description,
            createdBy: userIdFromSession,
            isActive: true,
          };

          const responseKey = props.isEditing ? "updatedMethod" : "newMethod";

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateDepreciationMethod" : "createDepreciationMethod",
        mutationData,
        responseKey,
        base_url
      );

      if (response && Object.values(response)[0] != null) {
        props.onClose?.();
        props.refetchData?.();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Category ${props.isEditing ? "updated" : "created"} successfully.`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: "Server did not return expected data. Please check API response.",
        });
      }
    } catch (error) {
      console.error("Category creation/update error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit depreciation method" : "Create depreciation method"}
        subtitle={
          props.isEditing
            ? "Edit an existing depreciation method record"
            : "Create a new depreciation method record"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              {/* Category Name */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Method Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.methodName}
                name="methodName"
                error={touched.methodName && !!errors.methodName}
                helperText={touched.methodName && errors.methodName}
                sx={{ gridColumn: "span 4" }}
              />

              {/* Description */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Description"
                multiline
                rows={3}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}
                sx={{ gridColumn: "span 4" }}
              />
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default DepreciationMethodsForm;
